module.exports = __webpack_public_path__ + "media/luxury-2026/stanwich-architectural-living-960-1b827c33.jpg";